"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importStar(require("react"));
const GridComponent_1 = __importDefault(require("~/components/UI/GridComponent/GridComponent"));
const UI_1 = require("~/components/UI");
const utils_1 = require("~/utils/utils");
const assets_1 = require("~/assets");
const types_1 = require("~/store/types");
const react_i18next_1 = require("react-i18next");
const selectors_1 = require("~/store/selectors");
const react_redux_1 = require("react-redux");
const consts_1 = require("~/components/Cad3d/consts");
const MachiningServiceMetadata_scss_1 = __importDefault(require("./MachiningServiceMetadata.scss"));
function generateSlotOptions(slotNumbers) {
    const slotOptions = slotNumbers.map((slotNumber) => ({
        id: slotNumber,
        value: slotNumber.toString(),
        label: slotNumber.toString(),
    }));
    slotOptions.push({
        id: 0,
        disabled: true,
        value: null,
        label: 'None',
    });
    return slotOptions;
}
function MachiningServiceMetadata({ item, serviceMetadata, onChange, onDelete, canBeDeleted, }) {
    var _a, _b, _c, _d, _e;
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const isImperialMeasurement = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    const distance = (0, react_1.useMemo)(() => isImperialMeasurement || !serviceMetadata.distance
        ? serviceMetadata.distance
        : (0, utils_1.convertToSI)({ size: serviceMetadata.distance, unitOfMeasurement: 'IN' }).size, [isImperialMeasurement, serviceMetadata]);
    const slotNumberOptions = (0, react_1.useMemo)(() => { var _a, _b; return generateSlotOptions((_b = (_a = item.extrusionType) === null || _a === void 0 ? void 0 : _a.slotNumbers) !== null && _b !== void 0 ? _b : []); }, [(_a = item.extrusionType) === null || _a === void 0 ? void 0 : _a.slotNumbers]);
    const onEndFaceChange = (value) => {
        onChange('endFace', value);
    };
    const onSlotNumberChange = (value) => {
        const valueAsNumber = Number(value);
        if (!Number.isNaN(valueAsNumber) && Number.isFinite(valueAsNumber)) {
            onChange('slotNumber', valueAsNumber);
        }
    };
    const onDistanceChange = (value) => {
        const parsedValue = (0, utils_1.roundToDecimals)(Number.parseFloat(value), 3);
        const distanceInInches = isImperialMeasurement ? parsedValue : parsedValue / consts_1.consts.INCH_TO_MM;
        if (!Number.isNaN(distanceInInches) && Number.isFinite(distanceInInches)) {
            onChange('distance', distanceInInches);
        }
    };
    const onAngleChange = (value) => {
        const floatValue = (0, utils_1.roundToDecimals)(Number.parseFloat(value), 3);
        if (!Number.isNaN(floatValue) && Number.isFinite(floatValue)) {
            onChange('angle', floatValue);
        }
    };
    return (react_1.default.createElement("div", { className: MachiningServiceMetadata_scss_1.default.row },
        react_1.default.createElement(GridComponent_1.default, { rows: 1, cols: 4, colFractions: [1, 1, 1.1, 1] },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, t('ms.end-face')),
                react_1.default.createElement(UI_1.Select, { options: [
                        {
                            id: 0,
                            disabled: true,
                            label: 'None',
                            value: null,
                        },
                        {
                            id: 1,
                            label: types_1.EndFace.A,
                            value: types_1.EndFace.A,
                        },
                        {
                            id: 2,
                            label: types_1.EndFace.B,
                            value: types_1.EndFace.B,
                        },
                        {
                            id: 3,
                            label: types_1.EndFace.AB,
                            value: types_1.EndFace.AB,
                        },
                    ], selected: {
                        value: (_b = serviceMetadata.endFace) !== null && _b !== void 0 ? _b : null,
                        label: (_c = serviceMetadata.endFace) !== null && _c !== void 0 ? _c : 'None',
                    }, onChange: onEndFaceChange })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, t('ms.slot-number')),
                react_1.default.createElement(UI_1.Select, { selected: {
                        label: (_d = serviceMetadata.slotNumber) !== null && _d !== void 0 ? _d : 'Optional',
                        value: serviceMetadata.slotNumber ? serviceMetadata.slotNumber.toString() : null,
                    }, options: slotNumberOptions, onChange: onSlotNumberChange })),
            item.stockLength && (react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, t('ms.distance')),
                react_1.default.createElement("div", { className: MachiningServiceMetadata_scss_1.default.inputRow },
                    react_1.default.createElement(UI_1.Input, { type: "number", value: distance ? (0, utils_1.roundWithoutTrailingZeros)(distance, 3) : null, onChange: onDistanceChange, step: isImperialMeasurement ? consts_1.consts.DEFAULT_EXTRUDE_STEP : consts_1.consts.DEFAULT_EXTRUDE_STEP_MM, precision: 3, min: isImperialMeasurement ? 1 : consts_1.consts.INCH_TO_MM, max: isImperialMeasurement ? item.stockLength : item.stockLength * consts_1.consts.INCH_TO_MM, placeholder: "Optional" }),
                    react_1.default.createElement("div", { className: MachiningServiceMetadata_scss_1.default.unitsOfMeasurement }, isImperialMeasurement ? 'IN' : 'MM')))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, t('ms.angle')),
                react_1.default.createElement(UI_1.Input, { type: "number", value: (_e = serviceMetadata.angle) !== null && _e !== void 0 ? _e : null, onChange: onAngleChange, step: 1e-3, precision: 3, min: 30, max: 60, placeholder: "Optional" }))),
        react_1.default.createElement("div", { className: `${MachiningServiceMetadata_scss_1.default.trashIcon} ${!canBeDeleted ? MachiningServiceMetadata_scss_1.default.invisible : ''}` },
            react_1.default.createElement("img", { src: assets_1.svgBasicTrashIcon, alt: "Delete row", onClick: onDelete }))));
}
exports.default = MachiningServiceMetadata;
